import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-fi-ss-hand-holding-usd",
  "use": "icon-fi-ss-hand-holding-usd-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-fi-ss-hand-holding-usd\"><path d=\"M23.34,12.35l-10.67,11.65H3c-1.65,0-3-1.35-3-3v-7c0-1.65,1.35-3,3-3H7v-1c-1.65,0-3-1.35-3-3h2c0,.55,.45,1,1,1h2.38c.34,0,.62-.28,.62-.62,0-.31-.22-.57-.52-.62l-3.29-.55c-1.27-.21-2.19-1.3-2.19-2.59,0-1.45,1.18-2.62,2.62-2.62h.38V0h2V1c1.65,0,3,1.35,3,3h-2c0-.55-.45-1-1-1h-2.38c-.34,0-.62,.28-.62,.62,0,.31,.22,.57,.52,.62l3.29,.55c1.27,.21,2.19,1.3,2.19,2.59,0,1.45-1.18,2.62-2.62,2.62h-.38v1h2.79c1.22,0,2.21,.99,2.21,2.21,0,1.09-.82,2.04-1.9,2.19l-4.24,.61,.28,1.98,4.24-.61c2.06-.29,3.62-2.09,3.62-4.17,0-.22-.03-.43-.06-.64l3.54-3.74c.46-.5,1.1-.8,1.79-.83,.69-.03,1.36,.21,1.88,.68,1.05,.96,1.14,2.6,.19,3.66Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/fi-ss-hand-holding-usd.svg
// module id = EU67
// module chunks = 63